import { useState } from "react";
import SyIcon from "../../../../../shared/components/sy-icon";
import styleSheet from "../style.module.scss";
import { profileConfig, statusOption } from "../profile-config";
import SyCard from "../../../../../shared/components/sy-card";
import { Controller, useForm } from "react-hook-form";
import OrbInput from "../../../../../shared/forms/orb-input";
import SyDropdown from "../../../../../shared/forms/sy-dropdown";
import { useDispatch, useSelector } from "react-redux";
import { getImageDetails } from "../../../../../feature/image-slice";
import SySlider from "../../../../../shared/components/sy-slider";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../../services/orbit-service";
import {
  getAuthDetails,
  setUserImage,
} from "../../../../../feature/auth-slice";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import OrbAvatar from "../../../../../shared/components/orb-avatar";
const ProfileDetail = (props: any) => {
  const { profileData, onClose, updateProfileData } = props;
  const { profileId } = useParams();
  const [editProfile, setEditProfile] = useState<boolean>(false);
  const imageDetails = useSelector(getImageDetails);
  const [userImgType, setUserImgType] = useState<any>(null);
  const dispatch = useDispatch();
  const authSlice = useSelector(getAuthDetails);
  const { t } = useTranslation();
  const getStatus = (id: any) => {
    const defaultStatus = statusOption.find((data: any) => data.id === id);
    return defaultStatus;
  };
  const defaultValues = {
    usr_id: profileData.usr_id,
    usr_fname: profileData.usr_fname,
    usr_lname: profileData.usr_lname,
    usr_status: getStatus(profileData.usr_status),
    usr_email: profileData.usr_email,
    usr_phone: profileData.usr_phone,
    usr_cat_id: profileData.usr_cat_id,
  };

  const {
    setValue,
    getValues,
    control,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues,
  });

  const formvalue: any = getValues();

  const handleStatusFilter = () => void 0;
  const handleStatusLabel = (data: any) => data?.label;

  const onEditProfile = (type: any) => {
    setEditProfile(!editProfile);

    if (type === "save") {
      const payload = getValues();
      payload.usr_cat_id = userImgType.id;
      payload.usr_status = payload.usr_status.id;
      updateProfileData("save", payload);
    }
  };

  const onSelectUser = (data: any) => {
    setUserImgType(data);
  };

  const onChanceVal = (e: any) => {
    let val = {};
    if (e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      val = {
        id: profileData.usr_id,
        value: formData,
      };
    } else {
      val = {
        id: profileData.usr_id,
        value: {},
      };
    }
    uploadprofileImg(val);
  };

  const { mutate: uploadprofileImg } = useMutation({
    mutationFn: orbitService.uploadprofileImg,
    onSuccess(data, variables, context) {
      getProfileImg(profileData.usr_id);
      updateProfileData("details");
    },
  });
  const { mutate: getProfileImg } = useMutation({
    mutationFn: orbitService.getProfileImg,
    onSuccess(data, variables, context) {
      dispatch(setUserImage(data.data.imageUrl));
    },
  });

  const ContactDetail = (contactProps: any) => {
    const { formData } = contactProps;
    const getChipValue = (name: any) => {
      return formvalue[name]?.label ? formvalue[name]?.label : formvalue[name];
    };
    return (
      <>
        {editProfile ? (
          <div className="pe-2">
            <p className="mohave sub-font text-white m-0">
              {t(formData.placeHolder)}
            </p>
            <Controller
              name={formData.formName}
              control={control}
              render={({ field: { onChange, value } }) => {
                return formData.formName !== "usr_status" ? (
                  <OrbInput
                    type={"text"}
                    value={value}
                    onChange={onChange}
                    errorMessage={errors[formData.formName]?.message || ""}
                  />
                ) : (
                  <SyDropdown
                    options={statusOption}
                    handleFilter={handleStatusFilter}
                    handleChange={onChange}
                    getoptlabel={handleStatusLabel}
                    value={value}
                    clearIcon={true}
                  />
                );
              }}
            />
          </div>
        ) : (
          <div className={` ${styleSheet.chip_animate} pb-2 pe-2`}>
            <SyCard
              title={t(formData.placeHolder)}
              text={getChipValue(formData.formName)}
              chipColor={"#7A9D54"}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <div className="p-2 h-100 sy-scroll-y   ">
      <div className="d-flex justify-content-end ">
        <SyIcon
          name={"close"}
          iconColor="rgba(255, 255, 255, 0.3)"
          className={"pointer pt-2 px-2"}
          onClick={onClose}
        />
      </div>

      <div className="row  ">
        <div className="col-lg-8 col-md-6 col-md-12">
          <div className=" row   px-2">
            <div className="d-flex col">
              <OrbAvatar
                file={profileData.imageUrl}
                fileUpload={true}
                className={`${styleSheet.avatar_style}`}
                onChanceVal={onChanceVal}
              />
              <div className={`ps-3  ${styleSheet.avatar_details}`}>
                <h1 className=" m-0 bebas-neue text-white ellipsis">
                  {profileData.usr_name}
                </h1>
                <h5 className=" m-0  mohave text-white ellipsis ">
                  {profileData.usr_email}
                </h5>
              </div>
            </div>

            <div className="col">
              {profileId == authSlice.user_details.usr_id ? (
                <SyIcon
                  name={editProfile ? "save" : "edit"}
                  iconColor="white"
                  className={
                    "pointer d-flex align-items-end justify-content-end"
                  }
                  onClick={() => onEditProfile(editProfile ? "save" : "edit")}
                />
              ) : null}
            </div>
          </div>
          <div className="d-flex  flex-wrap my-3  px-2">
            {profileConfig.map((data: any) => {
              return <ContactDetail formData={data} />;
            })}
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-md-12 mt-5  ">
          <div className=" h-100 mt-5 ">
            <div className="d-flex w-100 justify-content-center ">
              <h6 className="text-white mohave mb-4">{t("select_pilot")}</h6>
            </div>
            {profileData && imageDetails.user && (
              <SySlider
                slide={editProfile}
                image={imageDetails.user}
                onSelected={onSelectUser}
                size={"lg"}
                value={profileData.cat_id}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetail;
